const DEFAULT_GOOGLE_CLIENT_ID =
  "152208487414-3m7sbhsscdf29k1amt6maibae3cuspru.apps.googleusercontent.com";

export const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || DEFAULT_GOOGLE_CLIENT_ID;

export const isGoogleOAuthEnabled = (() => {
  if (process.env.REACT_APP_ENABLE_GOOGLE_OAUTH === "false") return false;
  if (!googleClientId) return false;

  // Avoid noisy CORS/403 errors during local development/audits unless explicitly allowed.
  const allowLocal = process.env.REACT_APP_GOOGLE_OAUTH_ALLOW_LOCAL === "true";
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const isLocalhost = host === "localhost" || host === "127.0.0.1";
    if (isLocalhost && !allowLocal) return false;
  }

  return true;
})();

